var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('motlet',{attrs:{"options":_vm.motletOptions},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('v-card',{staticClass:"scroll",attrs:{"max-height":_vm.params.height,"flat":""}},[_vm._v(_vm._s(_vm.value))])]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }